import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getParticipantCountForDisplay } from '../../../base/participants/functions';
const useStyles = makeStyles()(theme => {
    return {
        badge: {
            alignItems: 'center',
            backgroundColor: theme.palette.participantCounterBadge,
            borderRadius: '100%',
            boxSizing: 'border-box',
            display: 'inline-flex',
            height: '16px',
            justifyContent: 'center',
            minWidth: '16px',
            color: theme.palette.participantCounterText,
            ...theme.typography.labelBold,
            lineHeight: 1,
            pointerEvents: 'none',
            position: 'absolute',
            right: '-4px',
            top: '-3px',
            textAlign: 'center',
            padding: '1px'
        }
    };
});
const ParticipantsCounter = () => {
    const { classes } = useStyles();
    const participantsCount = useSelector(getParticipantCountForDisplay);
    return React.createElement("span", { className: classes.badge }, participantsCount);
};
export default ParticipantsCounter;
